// extracted by mini-css-extract-plugin
export default {"link":"_8TIz4+gU66","primary":"EL9l6xNqb1","secondary":"bJGNRXKBNz","link-visited":"X-JFOjwN6N","linkVisited":"X-JFOjwN6N","disabled":"+3TIPMO8BM","doc-link":"GhlXJoSGf1","docLink":"GhlXJoSGf1","icon":"i4Dn6TGGci","doc-icon":"ku9YzK98yz","docIcon":"ku9YzK98yz"};
    if(module.hot) {
      // 1653462668346
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  